export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/music_promotion.ff54da0.svg";